(function ($, Global) {
    var urlParams = new UrlParams();
    function FiltersComponent() {
        // Déclaration class objet
    }

    FiltersComponent.prototype.initEvents = function () {
        this.publishers();
        this.subscribers();
    }

    FiltersComponent.prototype.publishers = function () {
        $(document).ready(function () {
            $('.formFilters [type="hidden"]').each(function () {
                var keyName = $(this).attr('name');
                var value = $(this).attr('value');

                urlParams.setParam(keyName, value);
            });

            if (!urlParams.getPathName().includes('free') && (urlParams.getParam('Country') || urlParams.getParam('Region') || urlParams.getParam('Theme') || urlParams.getParam('Secteur') || urlParams.getParam('Section'))) {
                $.Topic('filters-changed').publish();
                if ($('.page-liste .filter-line').exists() && urlParams.getParam('Section')) {
                    var $el = $('.filter-line #' + urlParams.getParam('Section'))
                    $('.filter-line button .section-count').html($el.data('search'))
                }
            }

        });

        $(document).on('click', '#btnResetFiltres', function (e) {
            var params = urlParams.getParams();

            urlParams.resetParams();
            if (params.sqe) {
                urlParams.setParam('sqe', params.sqe);
            };

            document.location.reload(true);
        });

        $(document).on('change', '.rubrique .formFilters input, .rubrique .formFilters select, input[name="Subscription"], .page-tag .formFilters input', function () {
            if (!$(this).hasClass('datepicker')) {
                $.Topic('filters-change').publish(this);
            }
        });

        $(document).on('change', '.page-liste-format .filter-line input, .page-liste-format .filter-line-mobile input,.page.page-liste .filter-line input, .page.page-liste .filter-line-mobile input', function () {
            $.Topic('filters-change').publish(this);
            var $el = $(this);
            $('.filter-line button .section-count').html($el.data('search'))
        });

        $(document).on('changeDate', '.sidenav .formFilters .datepicker', function () {
            $.Topic('filters-change').publish(this);
        });

        $(document).on('show.bs.dropdown', '.filter-line, .nav-rubrique-line', function () {
            $('body, .screen-backdrop').addClass('in full');
            $('.btn-filter-mobile span').replaceClass('icon-130', 'icon-112')
        });

        $(document).on('hide.bs.dropdown', '.filter-line, .nav-rubrique-line', function () {
            $('body, .screen-backdrop').removeClass('in full');
            $('.btn-filter-mobile span').replaceClass('icon-112', 'icon-130')
        });

        $(document).on('click', '.btn-filter-mobile', function (e) {
            toggleDropdownMobile();
        });
        $(document).on('click', '.screen-backdrop', function (e) {
            var selector = $('.nav-rubrique-line-mobile').exists() ? '.nav-rubrique-line-mobile' : '.filter-line-mobile';

            $('body, .screen-backdrop')['removeClass']('in')
            $(selector + ' .dropdown-menu')['removeClass']('show')

            $(selector + ' .btn-filter-mobile span').replaceClass('icon-112', 'icon-130')
        });

        $(document).on('click', '.btn-all-section', function () {
            var newUrlParams = new UrlParams();
            newUrlParams.resetParams();
            document.location.reload(true);
        })
    }

    FiltersComponent.prototype.subscribers = function () {
        var self = this;

        $.Topic('filters-change').subscribe(function (el) {
            var $el = $(el);
            var $parent = $el.closest('.formFilters');
            var keyName = $el.attr('name');
            var value = $el.val();

            if ($el.data('type-search') === "region") {
                setCountryParam();
            }

            if (($el.tagName() == 'INPUT') && ($el.attr('type').toLowerCase() == 'checkbox')) {
                setCheckboxParam($el, keyName, value)
            } else {
                urlParams.setParam(keyName, value);
            }

            if (keyName == 'Date') {
                setDateParam();
            }

            if (keyName == 'Country' && $parent.find('[name="CountryAIBehavior"]').exists()) {
                return Global.location.replace($el.val());
            }

            $('.filter-line-mobile .dropdown, .filter-line-mobile .dropdown-menu').removeClass('show');
            $('.filter-line .dropdown-menu, .filter-line .dropdown').removeClass('show');
            $('.screen-backdrop').removeClass('in').removeClass('full');
            self.setButtonMobile();
            self.setFilter(value);
            $.Topic('filters-changed').publish();
        });
    }

    FiltersComponent.prototype.setFilter = function (value) {
        $('.filter-line-mobile .form-check-input').each(function (x) {
            if ($(this).val() != value) $(this).prop('checked', false);
        })
        $('.filter-line .form-check-input').each(function (x) {
            if ($(this).val() != value) $(this).prop('checked', false);
        })
    }
    FiltersComponent.prototype.setButtonMobile = function (value) {
        if ($('.btn-filter-mobile span').hasClass('icon-112')) {
            $('.btn-filter-mobile span').replaceClass('icon-112', 'icon-130')
        } else {
            $('.btn-filter-mobile span').replaceClass('icon-130', 'icon-112');
        }
    }

    function setCountryParam() {
        $('select[name="Country"]').each(function () {
            $(this).val($(this).find("option:first").val());
        });
        urlParams.setParam('Country', '');
    }

    function setDateParam() {
        $('.date-perso-content')[value == 'Custom' ? 'removeClass' : 'addClass']('hidden');
    }

    function setCheckboxParam(el, keyName, value) {
        if (el.val() == 'on') {
            urlParams.setParam(keyName, el.is(':checked') ? 'true' : 'false');
        } else {
            var paramValue = urlParams.getParam(keyName) || '';

            if (el.is(':checked')) {
                paramValue += ',' + value;
            } else {
                paramValue = paramValue.replace(',' + value, '');
            }

            urlParams.setParam(keyName, paramValue);
        }
    }

    function toggleDropdownMobile() {
        var selector = $('.nav-rubrique-line-mobile').exists() ? '.nav-rubrique-line-mobile' : '.filter-line-mobile';
        var isShown = $(selector + ' .dropdown-menu').hasClass('show');

        $('body, .screen-backdrop')[isShown ? 'removeClass' : 'addClass']('in')
        $(selector + ' .dropdown-menu')[isShown ? 'removeClass' : 'addClass']('show')

        if (isShown) $(selector + ' .btn-filter-mobile span').replaceClass('icon-112', 'icon-130')
        else $(selector + ' .btn-filter-mobile span').replaceClass('icon-130', 'icon-112')
    }

    Global.FiltersComponent = FiltersComponent;
}(jQuery, window));